import React, { useState } from 'react';
import { History } from 'lucide-react';

const COLOR = { partiel_valide: 'bg-emerald-500', acquitte: 'bg-emerald-600', impaye: 'bg-orange-500', resilie: 'bg-red-600' };
const fmt = (iso) => (iso ? new Date(iso).toLocaleString('fr-FR', { dateStyle: 'short', timeStyle: 'short' }) : '—');

export const EtatHistorique = ({ items, testId = 'etat-historique' }) => {
  const [open, setOpen] = useState(false);
  if (!items?.length) return null;
  return (
    <div className="text-xs" data-testid={testId}>
      <button type="button" onClick={() => setOpen((o) => !o)} className="inline-flex items-center gap-1 text-slate-600 hover:text-slate-900 underline-offset-2 hover:underline" data-testid={`${testId}-toggle`}>
        <History className="h-3.5 w-3.5" /> Historique des états ({items.length})
      </button>
      {open && (
        <ol className="mt-2 space-y-1 border-l border-slate-200 pl-3" data-testid={`${testId}-liste`}>
          {[...items].reverse().map((e, i) => (
            <li key={`${e.at}-${i}`} className="flex items-center gap-2">
              <span className={`h-2 w-2 rounded-full ${COLOR[e.etat] || 'bg-slate-400'}`} />
              <span className="text-slate-500 tabular-nums">{fmt(e.at)}</span>
              <span className="font-medium text-slate-800">{e.label}</span>
              {e.mention && <span className="text-slate-500">— {e.mention}</span>}
            </li>
          ))}
        </ol>
      )}
    </div>
  );
};
